const TRAVEL_WITS_SUFFIX = '.travelwits.com';
const normalizeHost = (host = '') => String(host).split(':')[0].toLowerCase();

const parseHost = (rawHost = '') => {
  const host = normalizeHost(rawHost);
  const isTravelWitsDomain = host.endsWith(TRAVEL_WITS_SUFFIX);
  const tenant = isTravelWitsDomain
    ? host.replace(TRAVEL_WITS_SUFFIX, '')
    : host.split('.')[0] || '';
  return { host, tenant, isTravelWitsDomain };
};

export default parseHost;
